<div soho-busyindicator
     [style.height.%]="100"
     text=" "
     blockUI="true"
     displayDelay="20"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     transparentOverlay="true"
>
  <ng-template [ngIf]="getBasicData()">
    <div *ngIf="!hasChartData && getType() !== 'aggregation'" soho-emptymessage [emptyMessageOptions]="emptyMessage" style="text-align: center; padding-top: 30px; top: 30%"></div>

    <ng-template [ngIf]="hasChartData">
      <lm-chart-radar *ngIf="getType()==='gap'" #LMChartComponent class="lm-chart"
          [dataset]="getBasicData()"
          [type]="getType()"
          [showLegend]="showLegend()"
          [redrawOnResize]="true"
          [tooltip] = "tooltip"
          [showAxisLabels] = "showAxisLabels"
          [emptyMessage]="emptyMessage"
          [attr.data-automation-id]="getId()"

          (selected)="onSelected($event)"
          (rendered)="onRendered($event)"
          (unselected)="onUnselected($event)"
          (contextmenu)="onContextMenu($event)"
      ></lm-chart-radar>
      <!-- FOR GAP CHART
         (margin)="<xxx>", (levels)="<xxx>", (maxValue)="<xxx>", (labelFactor)="<xxx>", (wrapWidth)="<xxx>", (opacityArea)="<xxx>",
         (dotRadius)="<xxx>", (opacityCircles)="<xxx>", (strokeWidth)="<xxx>", (roundStrokes)="<xxx>", (showCrosslines)="<xxx>",
         (colors)="<xxx>", (tooltip)="<xxx>", (axisFormatter)="<xxx>", [legendPlacement]="bottom"
      -->

      <lm-chart-pie *ngIf="getType()==='pie' || getType()==='donut'" #LMChartComponent class="lm-chart"
          [dataset]="getBasicData()"
          [type]="getType()"
          [redrawOnResize]="true"
          [showLegend]="showLegend()"
          [showLines]="showLines()"
          [showLinesMobile]="showLinesMobile()"
          [hideCenterLabel]="hideCenterLabel()"
          [isDonut]="isDonut()"
          [lines]="getLines()"
          [legendPlacement]="legendPlacement()"
          [showTooltips]="showTooltips()"
          [emptyMessage]="emptyMessage"
          [attr.data-automation-id]="getId()"

          (selected)="onSelected($event)"
          (rendered)="onRendered($event)"
          (unselected)="onUnselected($event)"
          (contextmenu)="onContextMenu($event)"
      ></lm-chart-pie>
      <!-- FOR Pie CHART
           animationSpeed(value: number)    animate(value: any)    lines(value: SohoPieLinesOptions)  legend(value: SohoPieLegendOptions)
          showTooltips(value: boolean)
      -->

      <lm-chart-line *ngIf="getType()==='line' || getType()==='area' || getType()==='bubble'" #LMChartComponent class="lm-chart"
          [dataset]="getBasicData()"
          [type]="getType()"
          [redrawOnResize]="true"
          [showLegend]="showLegend()"
          [emptyMessage]="emptyMessage"
          [isArea]="isArea()"
          [isBubble]="isBubble()"
          [xAxisFields]="xAxisFields"
          [yAxisFields]="yAxisFields"
          [xAxisId] = "xAxisId"
          [yAxisId] = "yAxisId"
          [isDateChart]="isDateChart()"
          [hideDots]="hideDots()"
          [isDashBoardContent]="isDashBoardContent"
          [attr.data-automation-id]="getId()"

          (selected)="onSelected($event)"
          (rendered)="onRendered($event)"
          (unselected)="onUnselected($event)"
          (contextmenu)="onContextMenu($event)"
          (axisChanged)="onAxisChanged($event)"
      ></lm-chart-line>
      <!-- FOR Line CHART
             tooltip(value: string)  xAxis(value: object)  yAxis(value: object)  axisLabels(value: any)
             animate(value: boolean)  dots(value: object)
      -->

      <lm-chart-bar *ngIf="getType()==='bar-stacked' || getType()==='bar-grouped' " #LMChartComponent class="lm-chart"
          [dataset]="getBasicData()"
          [type]="getType()"
          [redrawOnResize]="true"
          [showLegend]="showLegend()"
          [emptyMessage]="emptyMessage"
          [isStacked]="isStacked()"
          [isNormalized]="isNormalized()"
          [isGrouped]="isGrouped()"
          [animate]="animate()"
          [attr.data-automation-id]="getId()"

          (selected)="onSelected($event)"
          (rendered)="onRendered($event)"
          (unselected)="onUnselected($event)"
          (contextmenu)="onContextMenu($event)"
      ></lm-chart-bar>

      <!-- FOR bar CHART formatterString(value: string)  format(value: string)  tooltip(value: string)  useLogScale(value: boolean)
          ticks(value: object[])  showLines(value: boolean)  labelFactor(value: number)  wrapWidth(value: number)
          -->

      <lm-chart-column *ngIf="getType()==='column-stacked' || getType()==='column-grouped' " #LMChartComponent class="lm-chart"
          [dataset]="getBasicData()"
          [type]="getType()"
          [redrawOnResize]="true"
          [showLegend]="showLegend()"
          [emptyMessage]="emptyMessage"
          [isStacked]="isStacked()"
          [animate]="animate()"
          [attr.data-automation-id]="getId()"

          (selected)="onSelected($event)"
          (rendered)="onRendered($event)"
          (unselected)="onUnselected($event)"
          (contextmenu)="onContextMenu($event)"
      ></lm-chart-column>

      <lm-list-chart-selectors *ngIf="this.isColumnarView && getType()!=='aggregation'"  #LMListChartSelectors
           [listSpec]="listSpec"
           [dataViewSet]="dataViewSet"
           [listState]="listState"
           [chartName]="_chartName"
      ></lm-list-chart-selectors>

      <!-- FOR column CHART
          format(value: string)    formatterString(value: string)   ticks(value: object[])
          -->

      <!--    <div *ngIf="getType()!='bar' && getType()!='gap' && getType()!='pie'  && getType()!='donut' && getType()!='line' && getType()!='area' && getType()!='bubble'" soho-chart
              [dataSet]="getBasicData()"
              [type]="getType()"
              [chartAnimate]="getChartAnimate()"
              [chartLabel]="getLabels()"
              [showLegend]="showLegend()"
              (selected)="onSelected($event)"
              (activated)="onActivated($event)"
              (rendered)="onRendered($event)"
              (contextmenu)="onContextMenu($event)"
          >
          </div>-->
    </ng-template>
  </ng-template>
  <ng-template [ngIf]="getType()==='aggregation'">
    <div class="scrollable-flex" [style.height]="'100%'">
      <div class="scrollable-flex-content">
        <lm-list-chart-aggregation *ngIf="getType()==='aggregation'" #LMListChartAggregation class="lm-chart"
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [fromDataView]="fromDataView"
            [listState]="listState"
            [filterCriteria]="filterCriteria"
            [sortOrder]="sortOrder"
            [listPersonalization]="listPersonalization"
            [chartName]="_chartName"
            [attr.data-automation-id]="getId()"
        ></lm-list-chart-aggregation>
      </div>
    </div>
  </ng-template>
</div>
